module.exports = __webpack_public_path__ + "img/icon_zhengfu@2x.b80686db.png";